module.exports = __webpack_public_path__ + "img/industrialblanco.1cffac29.png";